import React from "react";

import '../../style_new.css';

const Features = () => {
  return (
    <>
      {/* features section start */}
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="border-start border-5 border-primary ps-4 mb-5">
                <h6 class="text-body text-uppercase mb-2">Why Choose Us!</h6>
                <h1 class="display-6 mb-0">
                  Building Trust Through Quality & Commitment
                </h1>
              </div>
              <p class="mb-5">
                At Fair Vision Ventures, we specialize in delivering top-tier construction
                services tailored to meet your unique needs. From residential homes to
                commercial complexes, our dedication to craftsmanship, safety, and
                client satisfaction sets us apart in the industry.
              </p>
              <div class="row gy-5 gx-4">
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                    <h6 class="mb-0">Wide Range of Construction Services</h6>
                  </div>
                  <span>
                    From groundwork to turnkey projects, we handle every aspect of the build process with precision and care.
                  </span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                    <h6 class="mb-0">Over 14 Years of Industry Experience</h6>
                  </div>
                  <span>
                    Our team of seasoned professionals brings decades of expertise to every project we undertake.
                  </span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                    <h6 class="mb-0">Trusted by Hundreds of Satisfied Clients</h6>
                  </div>
                  <span>
                    We take pride in the long-term relationships we build through transparency and superior results.
                  </span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                    <h6 class="mb-0">Reliable, On-Time, and On-Budget Delivery</h6>
                  </div>
                  <span>
                    We deliver projects with precision, ensuring timely completion and cost-effective execution every time.
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div
                class="position-relative overflow-hidden ps-5 pt-5 h-100"
                style={{minHeight: '400px'}}>
                <img
                  class="position-absolute w-100 h-100"
                  src="./images/feature.jpg"
                  alt="Construction team at work"
                  style={{objectFit: 'cover'}}/>
                <div
                  class="position-absolute top-0 start-0 bg-white pe-3 pb-3"
                  style={{width: '200px', height: '200px'}}>
                  <div class="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 class="text-white">14</h1>
                    <h2 class="text-white">Years</h2>
                    <h5 class="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* features section end */}
    </>
  );
};

  
export default Features;